const OPTIONS = [
   { value: 'left', label: '⯇' },
   { value: 'center', label: '☰' },
   { value: 'right', label: '⯈' },
];

// Shared 3-way left/center/right control - used by all 3 block editors
// (heading/text/icon), each storing the result in its own block's `align`.
export default function AlignControl({ value, onChange }) {
   return (
      <div className='communication-align-control'>
         {OPTIONS.map((o) => (
            <button key={o.value} type='button'
               className={'communication-align-btn' + (value === o.value ? ' active' : '')}
               title={o.value} onClick={() => onChange(o.value)}>
               {o.label}
            </button>
         ))}
      </div>
   );
}
